import React, { FunctionComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicantDetailsContainer } from '../../containers';

const ApplicantDetailsPage: FunctionComponent<Props> = ({ match }) => (
    <ApplicantDetailsContainer
      applicantId={match.params.id}
      tab={match.params.tab}
    />
);

export default withRouter(ApplicantDetailsPage);

interface OwnProps {
    id: string;
    tab: string;
}

type Props = RouteComponentProps<OwnProps>
